export default {
  namespaced: true,
  state: {
    titlePresets: [],
  },
  getters: {
    getTitlePresets: (state) => () => {
      return state.titlePresets
    },
  },
  mutations: {    
    SET_TITLE_PRESETS(state, data) {
      state.titlePresets = data
    },
  },
  actions: {
    setTitlePresets({ commit }, titlePresets) {
      commit('SET_TITLE_PRESETS', titlePresets)
    },
  },
}
